<script setup>
const props = defineProps(['to', 'hash', 'href', 'disabled', 'processing', 'icon', 'iconBefore', 'target', 'label', 'simple'])
</script>

<template>
	<a class="btn group" v-if="href" :href="href" :target="target ?? '_blank'">
		<slot></slot>
		<div class="content whitespace-nowrap" :data-before="label" :data-after="label">
			<span class="invisible">{{ label }}</span>
		</div>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</a>
	<router-link class="btn group" v-else-if="to" :to="to">
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="iconBefore">
			<i :class="iconBefore"></i>
		</div>
		<slot></slot>
		<div class="content whitespace-nowrap" :data-before="label" :data-after="label">
			<span class="invisible">{{ label }}</span>
		</div>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</router-link>

	<button class="btn" v-else-if="simple" :disabled="disabled">
		<i class="fas fa-circle-notch fa-spin group animate-spin" v-if="processing"></i>
		<slot v-else></slot>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</button>

	<button class="btn" v-else :disabled="disabled">
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="iconBefore">
			<i :class="iconBefore"></i>
		</div>

		<div class="content paragraph md-alt font-paragraph whitespace-nowrap" :data-before="label" :data-after="label">
			<span class="invisible">{{ label }}</span>
		</div>

		<slot></slot>

		<i class="fas fa-circle-notch fa-spin group animate-spin" v-if="processing"></i>

		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</button>
</template>

<style scoped lang="scss">
.btn {
	@apply flex max-h-[40px] flex-row items-center justify-center gap-2 rounded-full px-4 py-3 font-bold text-[14px] leading-4;

	& > .content {
		@apply relative overflow-hidden;

		&::before {
			content: attr(data-before);
			@apply absolute transition-all duration-300 translate-y-0 rotate-x-0 transform;
		}

		&::after {
			content: attr(data-after);
			@apply absolute left-0 transition-all duration-300 translate-y-[50%] rotate-x-90;
		}
	}

	&:hover {
		& > .content {
			&::before {
				@apply -translate-y-[50%] rotate-x-90;
			}

			&::after {
				@apply translate-y-0 rotate-x-0;
			}
		}
	}
}

.btn:hover {
	@apply cursor-pointer transition-all;
}

.btn.primary {
	@apply bg-primaryMd text-bgMain;

	&:hover {
		@apply bg-primaryHover;
	}
}

.btn.secondary {
	@apply bg-secondary;

	&:hover {
		@apply bg-secondaryHover;
	}

	&:disabled {
		@apply bg-secondaryDisabled;
	}
}

.btn.outlined {
	@apply border border-borderGray transition-all;

	&:hover {
		@apply outline-2;
	}
}

.btn.small {
	@apply h-fit px-2 py-1;
}

.btn.large {
	@apply px-7 py-6;
}
.btn.large .content {
	@apply text-lg;
}
</style>
